import { render, staticRenderFns } from "./OrderConfirmationB2C.vue?vue&type=template&id=7d1775da&"
import script from "./OrderConfirmationB2C.ts?vue&type=script&lang=ts&"
export * from "./OrderConfirmationB2C.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports